import {
    ACCOUNT_SWITCH_PARAM,
    ACCOUNT_SWITCH_START_PARAM,
    LOGIN_HINT_PARAM,
    ACCOUNT_SWITCH_SOURCE_PARAM,
} from 'mini-mecontrol/lib/utils/accountSwitchParams';

export const getAndClearAccountSwitchParams = (): {
    srcSessionId: string;
    startTs: number;
} | null => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const actSwt = searchParams.get(ACCOUNT_SWITCH_PARAM);
    const srcSessionId = searchParams.get(ACCOUNT_SWITCH_SOURCE_PARAM);
    const startTs = parseInt(searchParams.get(ACCOUNT_SWITCH_START_PARAM));

    // Clear the query params from the URL
    [
        LOGIN_HINT_PARAM,
        ACCOUNT_SWITCH_PARAM,
        ACCOUNT_SWITCH_SOURCE_PARAM,
        ACCOUNT_SWITCH_START_PARAM,
    ].map(param => url.searchParams.delete(param));
    history.replaceState(history.state, '', url.toString());

    // Return the account switch params info if they are present
    if (actSwt && srcSessionId && !isNaN(startTs)) {
        return {
            srcSessionId,
            startTs,
        };
    }

    return null;
};
